import React, { useEffect, useState } from 'react';
import { api } from '../../../app/Api/ApiSlice';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Loader from '../../../components/Loader';
import InfiniteScroll from 'react-infinite-scroll-component';
import SentStoreBranchCard from '../../../components/SentStoreBranchCard';


// component for sent requests

const RequestedStoreBranches = () => {
    const [requestedBranches, setRequestedBranches] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);

    const { name } = useParams();

    useEffect(() => {
        const getRequestedBranches = async () => {
            try {
                setIsLoading(true);
                const response = await api.get(`/stores/${name}/manage/branches/requests/sent`, {
                    params: { page },
                });

                console.log("sent_requests:",response)

                const newBranches = response.data;

                setRequestedBranches((prev) =>
                    page === 1 ? newBranches : [...prev, ...newBranches]
                );

                // If fewer items are returned than expected, assume no more pages
                if (newBranches.length === 0 || newBranches.length < 10) {
                    setHasMore(false);
                }
            } catch (error) {
                toast.error(error?.response?.data?.message || 'Something went wrong');
                setHasMore(false);
            } finally {
                setIsLoading(false);
            }
        };

        getRequestedBranches();
    }, [page, name]);

    const handleRefresh = async () => {
        setPage(1);
        setHasMore(true);
    };

    return (
        <div>
            <h2 className='page-header-title'>Requested to be Branches</h2>
            <InfiniteScroll
                dataLength={requestedBranches?.length}
                next={() => setPage((prev) => prev + 1)}
                hasMore={hasMore}
                refreshFunction={handleRefresh}
                pullDownToRefresh
                pullDownToRefreshThreshold={50}
                pullDownToRefreshContent={
                    <h4 style={{ textAlign: 'center' }}>↓ Pull down to refresh</h4>
                }
                releaseToRefreshContent={
                    <h4 style={{ textAlign: 'center' }}>↑ Release to refresh</h4>
                }
                loader={<Loader />}
            >
                {requestedBranches?.length > 0 ? (
                    requestedBranches.map((b) => (
                        <div className="add-branch-container" key={b.id}>
                            <SentStoreBranchCard b={b} />
                        </div>
                    ))
                ) : (
                    !isLoading && <p className='not-found-msg'>No business has been requested to be branch</p>
                )}
            </InfiniteScroll>
        </div>
    );
};

export default RequestedStoreBranches;
